<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import Loading from "@/components/c-loading";
import { loanService } from "../../../services/paymentservice/loan.service";
import { customerService } from "../../../services/contactservice/customer.service";
import { servicehelpers } from "../../../services/servicehelpers";
import i18n from "../../../i18n";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Loan Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    Dropzone,
    Select,
    Search
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Loan",
      breadCrumb: {},
      currency: "",

      loanData: null,
      customerData: {},
      templeteData: {},
      termData:{},
      loanTypeData: {},
      currencyData: {},

      dataCode: '',
      dataDate: '',
      dataCustomer: 0,
      dataPaymentAccount: 0,
      dataProperty: 0,
      dataPaidAmount: 0,
      dataAmount: 0,
      dataBalance: 0,
      dataCurrency: 0,
      dataLoanType: 0,
      dataInterestRate: 0,
      dataInterestRateType: 0,
      dataLoanTerm: 0,
      dataLoanTermType: 0,
      dataMonthlyPayment: 0,
      dataStartDate: '',
      dataTemplate: 0,
      dataNotation: '',
      dataDoc: []

    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingCustomerData();
    this.loadingTemplateData(1);
    this.loadingCurrencyData();
    this.loadingTermData();
    this.loadingLoanTypeData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    }

    this.dataLoanTermType = "2";
    this.dataInterestType = "1";

    // console.log(this.dataCurrency);
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      loanService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.loanData = response;

          this.dataCode = this.loanData.data.code;
          this.dataDate = this.loanData.data.loan_date;
          this.dataCustomer = this.loanData.data.customer_id;
          this.dataPaymentAccount = this.loanData.data.payment_account_id;
          this.dataProperty = this.loanData.data.property_id;
          this.dataPaidAmount = this.loanData.data.paid_amount;
          this.dataAmount = this.loanData.data.amount;
          this.dataBalance = this.loanData.data.balance;
          this.dataCurrency = this.loanData.data.currency_id;
          this.dataLoanType = this.loanData.data.loan_type_id;
          this.dataInterestRate = this.loanData.data.interest_rate;
          this.dataInterestRateType = this.loanData.data.interest_rate_type;
          this.dataLoanTerm = this.loanData.data.loan_term;
          this.dataLoanTermType = this.loanData.data.loan_term_type;
          this.dataMonthlyPayment = this.loanData.data.monthly_payment;
          this.dataStartDate = this.loanData.data.start_date;
          this.dataTemplate = this.loanData.data.template_id;
          this.dataNotation = this.loanData.data.notation;

          this.loanData.data.collections.map(item => {
            if('loan_attachments' in item) {
              this.dataDoc = item.loan_attachments;
            } 
          });
        
        });
    },
    loadingCustomerData: function() {
      customerService.getList()
        .then(response => {
          this.customerData = response;
        });
    },
    loadingCurrencyData: function() {
      servicehelpers.getCurrencyData().then(response => {
        this.currencyData = response;
      });
    },
    loadingTermData: function() {
      servicehelpers.getTermData().then(response => {
        this.termData = response;
      });
    },
    loadingLoanTypeData: function() {
      servicehelpers.getLoanTypeData().then(response => {
        this.loanTypeData = response;
      });
    },
    loadingTemplateData: function(type = 0) {
      servicehelpers.getTemplateData(type).then(response => {
        this.templeteData = response;
      });
    },
    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "loan-list"
          });

        }
      });

      
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      let loan = {
        code: this.dataCode,
        customer_id: this.dataCustomer,
        payment_account_id: this.dataPaymentAccount,
        property_id: this.dataProperty,
        paid_amount: this.dataPaidAmount,
        amount: this.dataAmount,
        balance: this.dataBalance,
        currency_id: this.dataCurrency,
        loan_type_id: this.dataLoanType,
        interest_rate: this.dataInterestRate,
        interest_rate_type: this.dataInterestRateType,
        loan_term: this.dataLoanTerm,
        loan_term_type: this.dataLoanTermType,
        monthly_payment: this.dataMonthlyPayment,
        start_date: this.dataStartDate,
        template_id: this.dataTemplate,
        notation: this.dataNotation,
        loan_attachments: this.dataDoc

      };

      if(this.isAdd) {
        loanService.insert(loan)
         .then(response => {
           this.tryingToSubmit = false;

           console.log(response);

           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "loan-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(loan));
        loanService.update(this.$route.params.id, loan)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "loan-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },
    clearForm: function() {
      this.dataCode = '';
      this.dataCustomer = 0;
      this.dataPaymentAccount = 0;
      this.dataProperty = 0;
      this.dataPaidAmount = 0;
      this.dataAmount = 0;
      this.dataBalance = 0;
      this.dataCurrency = 0;
      this.dataLoanType = 0;
      this.dataInterestRate = 0;
      this.dataInterestRateType = 0;
      this.dataLoanTerm = 0;
      this.dataLoanTermType = 0;
      this.dataMonthlyPayment = 0;
      this.dataStartDate = '';
      this.dataTemplate = 0;
      this.dataNotation = '';
      this.dataDoc = [];
    },

    currencyChanged: function(event) {

      const cur = this.currencyData.data.find(obj => {
        return obj.id === event
      });

      this.currency = cur == null ? "" : cur.name_en;
    
    }, 
    uploadDocSuccess(file, response) {
        console.log(file);
        this.dataDoc.push(response.data);
    },

  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('loan.list'),
        href: '/general/loan',
      }, {
        text: $t('loan.new'),
        active: true
      }]" :title="this.isAdd ? $t('loan.new') : $t('loan.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('loan.list'),
        href: '/general/loan',
      }, this.breadCrumb]" :title="this.isAdd ? $t('loan.new') : $t('loan.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />

    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="mb-1">
                  <h4 class="card-title">{{$t('loan.customer-loan')}}</h4>
                  <p class="mb-4">{{$t('loan.sub-text')}}</p>
                  <hr/>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    v-model="dataCode"
                    :label="'loan.code'" 
                    :require="true"
                     /> 
                </div>

                <div class="col-md-4">
                  <Search 
                    :id="'customer_id'"
                    :text2="'name_en'"
                    :auto="true"
                    v-model="dataCustomer"
                    :list="this.customerData"
                    :require="true"
                    :label="'customer.text'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'date'"
                    :id="'loan_date'"
                    v-model="dataDate"
                    :label="'general.date'"  />
                </div>
              </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="mb-1">
                  <h4 class="card-title">{{$t('loan.amount-loan')}}</h4>
                  <p class="mb-4"> {{$t('loan.sub-amount-loan')}}</p>
                  <hr/>
                </div>
              </div>
               <div class="row">
                 <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'amount'"
                    v-model="dataAmount"
                    :label="'loan.amount'" 
                    :require="true"
                     /> 
                </div>
                <div class="col-md-6">
                  <Select
                    @change="currencyChanged" 
                    :id="'currency_id'"
                    :auto="true"
                    :text2="'name_en'"
                    v-model="dataCurrency"
                    :list="this.currencyData"
                    :label="'property.currency'"
                     /> 
                </div>
              </div>
              <div class="row">
                
                <div class="col-lg-6">
                  <Search 
                    :id="'loan_type_id'"
                    v-model="dataLoanType"
                    :list="this.loanTypeData"
                    :label="'loan.loan-type'"  />
                </div>
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-6">
                      <Input 
                        :type="'number'"
                        :id="'loan_term'"
                        v-model="dataLoanTerm"
                        :label="'loan.loan-term'"  />
                    </div>
                    <div class="col-lg-6">
                      <Select 
                :text="'name'"
                        :id="'loan_term_type'"
                        v-model="dataLoanTermType"
                        :list="this.termData"
                        :label="'loan.as'"
                        :require="true" />
                    </div>
                  </div>
                </div>
                
              </div>

              <div class="row">              
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-6">
                      <Input 
                        :type="'number'"
                        :id="'interest_rate'"
                        v-model="dataInterestRate"
                        :label="'loan.interest'"  />
                    </div>
                    <div class="col-lg-6">
                      <Select
                        :id="'interest_rate_type'"
                        :text2="'name_en'"
                        :auto="true"
                        v-model="dataInterestRateType"
                        :list="this.termData"
                        :label="'loan.as'"
                        /> 
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <Input 
                    :type="'number'"
                    :id="'monthly_payment'"
                    :disabled="true"
                    v-model="dataMonthlyPayment"
                    :label="'loan.payment'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <Input 
                    :type="'date'"
                    :id="'start_date'"
                    v-model="dataStartDate"
                    :label="'loan.start-date'"  />
                </div>
                <div class="col-lg-6" style="margin-top: 27px">
                  <Button v-bind:icon="'bx bx-calendar'" 
                    v-bind:buttonType="'button'"
                    v-bind:title="$t('loan.prview-schedule')"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-4"></div>
                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="mb-1">
                  <h4 class="card-title">{{$t('loan.attachment-text')}}</h4>
                  <p>{{$t('loan.attachment-sub-text')}}</p>
                  <hr/>
                </div>
              </div>
            <div class="row">
              <div class="col-md-12">
                 <Search 
                    :id="'template_id'"
                    v-model="dataTemplate"
                    :list="this.templeteData"
                    :label="'loan.contract-template'"  />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <Area 
                    :rows="2"
                    :id="'notation'"
                    v-model="dataNotation"
                    :label="'loan.notation'"  />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <Dropzone 
                  :id="'doc'"
                  :maxFiles="5"
                  :label="'loan.doc'" 
                  @uploadSuccess="uploadDocSuccess" />
              </div>
            </div>

          </div>
        </div>

      </div>
    </b-form> 
  </Layout>
</template>